import React, { useState, useEffect, useRef } from "react";
import JobPhotosTab from "../shared/tabs/JobPhotosTab";

const PiiHandoffJobPhotos = ({ piiHandoff, paramKey = "sales_pii_handoff" }) => {
  const [formData, setFormData] = useState({
    ...(piiHandoff || {}),
    existing_job_photos: (piiHandoff || {}).existing_additional_job_photos || [],
  });
  const fileInputRef = useRef(null);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (!fileInputRef.current) return;
    if (!formData.job_photos || formData.job_photos.length === 0) {
      fileInputRef.current.value = "";
      return;
    }
    const dataTransfer = new DataTransfer();
    formData.job_photos.forEach((file) => {
      if (file instanceof File) dataTransfer.items.add(file);
    });
    fileInputRef.current.files = dataTransfer.files;
  }, [formData.job_photos]);

  return (
    <div>
      <JobPhotosTab formData={formData} onChange={handleChange} />

      <input
        ref={fileInputRef}
        type="file"
        name={`${paramKey}[additional_job_photos][]`}
        multiple
        style={{ display: "none" }}
      />

      {formData.job_photos_to_remove &&
        formData.job_photos_to_remove.map((photoId, index) => (
          <input
            key={`photo-to-remove-${index}`}
            type="hidden"
            name={`${paramKey}[additional_job_photos_to_remove][]`}
            value={photoId}
          />
        ))}
    </div>
  );
};

export default PiiHandoffJobPhotos;
